import { Component, Input } from '@angular/core';
import { IUsuarioLog } from '../../interfaces/usuario-log.interface';

@Component({
  selector: 'sgt-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.scss'],
})
export class LogComponent {
  /** ID do usuário do log */
  @Input() idUsuario: number;
  /** Dados do log do usuário */
  @Input() log: IUsuarioLog | null = null;
}
